import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { InputField, InputLabel, InputSelectField } from '@presentation/components';
import { littersByFemaleOptions, motherRestBetweenLittersOptions } from '@application/utils';
import * as Styled from '../styled';

export const Step6: FC = () => {
  const { translate } = useTranslation();

  return (
    <>
      <Styled.BlueInfoBox full isFlex>
        💡 {translate('common.inputs.step5Warn')}
      </Styled.BlueInfoBox>
      <Styled.Step6Main>
        <Styled.OnboardingInputWrapper>
          <InputLabel requiredColor="red" required>
            {translate('common.inputs.femaleBreedersCount.label')}
          </InputLabel>
          <InputField
            type="number"
            name="femaleBreedersCount"
            min={0}
            required
            inputMode="numeric"
          />
        </Styled.OnboardingInputWrapper>
        <Styled.OnboardingInputWrapper>
          <InputLabel requiredColor="red" required>
            {translate('common.inputs.breedFemales.label')}
          </InputLabel>
          <InputSelectField
            name="motherRestBetweenLitters"
            options={motherRestBetweenLittersOptions(translate)}
            hasDropdownIcon
            variant="new"
            required
          />
        </Styled.OnboardingInputWrapper>
        <Styled.OnboardingInputWrapper>
          <InputLabel requiredColor="red" required>
            {translate('common.inputs.littersByFemale.label')}
          </InputLabel>
          <InputSelectField
            name="littersByFemale"
            options={littersByFemaleOptions}
            hasDropdownIcon
            variant="new"
            required
          />
        </Styled.OnboardingInputWrapper>
      </Styled.Step6Main>
    </>
  );
};
